import { c as _c } from "react/compiler-runtime";
import { getHostedUserAuthMethodsQueryKey } from '@onefootprint/fetch-hosted';
import type { ActionKind } from '@onefootprint/request-types';
import { createFileRoute, getRouteApi, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import RegisterPasskey from '@/idv2/features/liveness/register-passkey';
import { getLogger } from '@/idv2/utils/logger';
const {
  logInfo
} = getLogger({
  name: 'idv2',
  location: 'auth-methods-update-passkey'
});
const parentRoute = getRouteApi('/auth-methods');
const searchSchema = z.object({
  actionKind: z.enum(['add_primary', 'replace']).catch('add_primary')
});
export const Route = createFileRoute('/auth-methods/update-passkey')({
  component: UpdatePasskey,
  validateSearch: searchSchema
});
function UpdatePasskey() {
  const $ = _c(9);
  const navigate = useNavigate();
  const {
    actionKind
  } = Route.useSearch();
  const {
    token,
    deviceInfo
  } = parentRoute.useLoaderData();
  const {
    queryClient
  } = Route.useRouteContext();
  const isInIframe = typeof window !== "undefined" && window.self !== window.top;
  let t0;
  if ($[0] !== navigate || $[1] !== queryClient || $[2] !== token) {
    t0 = () => {
      logInfo("Passkey updated");
      queryClient.invalidateQueries({
        queryKey: getHostedUserAuthMethodsQueryKey({
          headers: {
            "X-Fp-Authorization": token
          }
        })
      });
      navigate({
        to: "/auth-methods"
      });
    };
    $[0] = navigate;
    $[1] = queryClient;
    $[2] = token;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const handleComplete = t0;
  const t1 = actionKind as ActionKind;
  let t2;
  if ($[4] !== deviceInfo || $[5] !== handleComplete || $[6] !== t1 || $[7] !== token) {
    t2 = <RegisterPasskey deviceInfo={deviceInfo} isInIframe={isInIframe} token={token} actionKind={t1} onComplete={handleComplete} />;
    $[4] = deviceInfo;
    $[5] = handleComplete;
    $[6] = t1;
    $[7] = token;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
}